export default "__VITE_ASSET__d0c96dc5__"